
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LaddaModule} from 'angular2-ladda';
import {UIRouterModule} from '@uirouter/angular';
import {RegistrationStates} from './registration.states';
import {ServiceModule} from '../services/service.module';
import {AccountValidationComponent} from './account-validation.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { RegistrationExistingUserComponent } from './registration-existing-user/registration-existing-user.component';
import { RegistrationNewUserComponent } from './registration-new-user/registration-new-user.component';
import { RegistrationValidationComponent } from './registration-validation/registration-validation.component';
import { RegistrationComponent } from './registration/registration.component';
import { RegistrationCompleteComponent } from './registration-complete/registration-complete.component';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { EdlAuthServicesModule, EdlCommonRegistrationModule } from '@edl-development/edl-auth';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        LaddaModule,
        UIRouterModule.forChild({
            states: RegistrationStates
        }),
        ServiceModule,
        NgbModule,
        ErrorTailorModule,
        EdlAuthServicesModule,
        EdlCommonRegistrationModule
    ],
    declarations: [
        RegistrationComponent,
        RegistrationCompleteComponent,
        RegistrationExistingUserComponent,
        RegistrationValidationComponent,
        RegistrationNewUserComponent,
        AccountValidationComponent
    ]
})
export class RegistrationModule {

}
